import { init as sentryInit } from '@sentry/vue'

export default defineNuxtPlugin(nuxtApp => {
	const config = useRuntimeConfig()
	sentryInit({
		app: nuxtApp.vueApp,
		dsn: '',
		environment: config.public.environment,
	})
})
